export default __webpack_public_path__ + "static/Leaf4-6539380a7f7c2613697f77c1e59c3b44.png";